export const AuthStepsMixin = {
  props: {
    showInvite: {
      default: function () {
        return null;
      },
    },
    personData: {
      default: function () {
        return null;
      },
    },
  },
  methods: {
    emitStep: function (newStep) {
      this.$emit('setStep', newStep);
    },
    updateValues: function (type) {
      const newPersonData = this.personData;
      switch (type) {
        case 'email':
          newPersonData.email = this.$refs.emailInput.value;
          break;
        case 'password':
          newPersonData.password = this.$refs.passwordInput.value;
          break;
      }
      this.$emit('updateValues', newPersonData);
    },
  },
};
